var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"x-tc-page-bg"},[_c('div',{staticClass:"x-tc-title douyuFont"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"x-close",on:{"click":_vm.closeClick}}),_c('div',{staticClass:"x-tc-cnt"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }